export default () => {
  const lessonMovieFile = document.getElementById('lesson_movie_file');
  const lessonMovieLabel = document.getElementById('lesson_movie_label');
  if (!lessonMovieFile) return;

  lessonMovieFile.addEventListener('change', (e) => {
    const file = e.target.files[0];
    const element = document.createElement('video');
    const fileURL = URL.createObjectURL(file);
    element.src = fileURL;
    element.ondurationchange = function () {
      const duration = this.duration;
      if (duration < 50 * 60) {
        if (!confirm('再生時間が50分未満の動画です。このままアップロードしてよろしいですか？')) {
          lessonMovieFile.value = '';
          lessonMovieLabel.textContent = 'ファイルを選択';
        }
      }
      URL.revokeObjectURL(this.src);
    };
  });
};
